package com.klantenstop.web.styles

import com.materialkobweb.theme.ColorScheme
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.px

object LeafletClusterStyles : StyleSheet() {

    init {
        leafletClusterStyling(".silk-light", KsLightColorScheme)
        leafletClusterStyling(".silk-dark", KsDarkColorScheme)
    }

    private fun leafletClusterStyling(colorMode: String, colorScheme: ColorScheme) {

        // Cluster markers
        "$colorMode .marker-cluster-small" style {
            backgroundColor(colorScheme.primaryContainer.toRgb().copyf(alpha = 0.5f))
        }

        "$colorMode .marker-cluster-small div" style {
            backgroundColor(colorScheme.primaryContainer)
            color(colorScheme.onPrimaryContainer)
        }

        "$colorMode .marker-cluster-medium" style {
            backgroundColor(colorScheme.primaryContainer.toRgb().copyf(alpha = 0.5f))
        }

        "$colorMode .marker-cluster-medium div" style {
            backgroundColor(colorScheme.primaryContainer)
            color(colorScheme.onPrimaryContainer)
        }

        "$colorMode .marker-cluster-large" style {
            backgroundColor(colorScheme.primaryContainer.toRgb().copyf(alpha = 0.5f))
        }

        "$colorMode .marker-cluster-large div" style {
            backgroundColor(colorScheme.primaryContainer)
            color(colorScheme.onPrimaryContainer)
        }

        // Popup styles for light mode
        "$colorMode .leaflet-popup-content-wrapper" style {
            backgroundColor(colorScheme.surfaceContainerHigh)
            color(colorScheme.onSurface)
            borderRadius(12.px)
            property("box-shadow", "0px 4px 8px rgba(0, 0, 0, 0.1)")
        }

        "$colorMode .leaflet-popup-tip" style {
            backgroundColor(colorScheme.surfaceContainerHigh)
        }

        // Close button styling
        "$colorMode .leaflet-popup-close-button" style {
            color(colorScheme.onSurfaceVariant)
        }
    }
}
